import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";

export const ResetPasswordPage = ({ resetPassword, isReset, isLoading }) => {
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const { token } = useParams();

  const onSubmit = (data) => {
    resetPassword(token, data);
  };

  return (
    <>
      <div className="full-row bg-light overlay-dark py-5"
        style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <h3 className="mb-2 text-white font-weight-bold">Reset Password Page</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center bg-transparent">
                  <li className="breadcrumb-item">
                    <a href="#" className="text-white">Home</a>
                  </li>
                  <li className="breadcrumb-item active text-white" aria-current="page">Reset Passowrd</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div className="container d-flex justify-content-center align-items-center py-5">
        <div className="card p-4" style={{width: "100%", maxWidth: "600px"}}>
          <h4 className="mb-4" style={{fontWeight: 700, fontSize: "30px"}}>Reset password</h4>
          <form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label for="password" className="form-label text-secondary">Password<span className="text-danger">*</span></label>
              <input type="password" name="password" {...register('password', { required: 'Password is required' })} className="form-control" id="password" placeholder="Type Password"/>
              {errors.password && <p className="text-danger px-2">{errors.password.message}</p>}
            </div>
            <div className="mb-3">
              <label for="confirm_password" className="form-label text-secondary">Confirm Password<span className="text-danger">*</span></label>
              <input type="password" name="confirm_password" {...register('confirm_password', {
                                        required: "Please confirm your password",
                                        validate: (value) =>
                                          value === watch("password") || "Passwords do not match",
                                      })} className="form-control" id="confirm_password" placeholder="Type Password"/>
              {errors.confirm_password && <p className="text-danger px-2">{errors.confirm_password.message}</p>}
            </div>
            <div className="d-flex justify-content-between mb-3">
              <Link to="/login" className="text-decoration-none text-dark">Login Now</Link>
            </div>

            <button type="submit" className="btn w-100"
              style={{backgroundColor: "#424A4D", borderRadius: 0, color: "white", height: "40px"}}>Reset Password</button>
          </form>
        </div>
      </div>
    </>
  );
};
